module.exports = __webpack_public_path__ + "img/rec-18.1d3575f4.png";